import { useQuery } from '@tanstack/react-query';
import { SPECIAL_AGENT_IDS } from '@/entities/agent';
import { getAgentAssignedMcpIds, USER_MCP_QUERY_KEYS } from '../../api';

// Stable empty reference so consumers' memo deps don't churn while the query is idle/loading.
const NO_IDS: string[] = [];

/**
 * The MCP servers a built agent uses, from its card. The chat composer feeds these into
 * `useAgentMcpStatus` to resolve per-server connection status. Returns `[]` until loaded so the
 * status hook can stay pure (it just receives ids).
 *
 * Asked only about built agents: platform agents name their servers in code, not on the card.
 */
export const useAgentAssignedMcpIds = (agentId: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: USER_MCP_QUERY_KEYS.agentAssigned(agentId ?? ''),
    queryFn: () => getAgentAssignedMcpIds(agentId!),
    enabled: agentId?.startsWith(SPECIAL_AGENT_IDS.AGENT_DEFINITION_PREFIX) ?? false,
    staleTime: 5 * 60 * 1000,
  });
  return { mcpServerIds: data ?? NO_IDS, isLoading };
};
